export const AUDITORY_MODEL = {
  paso: 1,
  pasoDescripcion: "PASO_COTIZACION",
};

export const PLANS_MODEL = {
  paymentFrequencyList: [
    {
      text: "Mensual",
      value: "12",
      name: "mensual",
    },
    {
      text: "Anual",
      value: "1",
      name: "anual",
    },
    {
      text: "Semestral",
      value: "2",
      name: "semestral",
    },
  ],
  errorStep: "/comprar/seguro-vida-devolucion-garantizada/error",
  pathQuoteError:
    "/comprar/seguro-vida-devolucion-garantizada/cotizacion/gracias-prima",
  nextStep: "/comprar/seguro-vida-devolucion-garantizada/direccion",
  urlHome: "/comprar/seguro-vida-devolucion-garantizada",
};
